import { store } from "../store";

export const hasCapability = capability => {
  const { user } = store.getState();
  return (
    user.is_owner ||
    user.is_primary_owner ||
    user.capabilities.includes(capability)
  );
};

export const isOwner = () => {
  const { user } = store.getState();
  return user.is_owner || user.is_primary_owner;
};

export const VIEW_REIMBURSEMENTS = "VIEW_REIMBURSEMENTS";
export const APPROVE_REIMBURSEMENTS = "APPROVE_REIMBURSEMENTS";
export const PAY_REIMBURSEMENTS = "PAY_REIMBURSEMENTS";
export const MODIFY_SUBMITTERS = "MODIFY_SUBMITTERS";
export const MODIFY_ORGANIZATION = "MODIFY_ORGANIZATION";
export const VIEW_TRANSACTIONS = "VIEW_TRANSACTIONS";



// WEBPACK FOOTER //
// ./frontend/src/util/capability.js